import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Mail, Phone, MapPin, Send, MessageCircle, HelpCircle, Sparkles } from "lucide-react";
import { Helmet } from "react-helmet-async";

export default function Help() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 15 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // വാട്സാപ്പ് നമ്പർ
    const whatsappNumber = "917306422610"; 
    const text = `*New Message via INFO PAYANGADI*%0A%0A*Name:* ${name}%0A*Phone:* ${phone}%0A*Message:* ${message}`;
    
    window.open(`https://wa.me/${whatsappNumber}?text=${text}`, "_blank");
    
    setName("");
    setPhone("");
    setMessage("");
  };

  // 🔥 Updated & Expanded FAQs 🔥
  const faqs = [
    {
      q: "എങ്ങനെയാണ് പുതിയ അക്കൗണ്ട് നിർമ്മിക്കുന്നത് (Sign Up)?",
      a: "ഏറ്റവും എളുപ്പത്തിൽ 'Continue with Google' ബട്ടൺ ഉപയോഗിച്ച് ഒറ്റ ക്ലിക്കിൽ നിങ്ങൾക്ക് പുതിയ അക്കൗണ്ട് നിർമ്മിക്കാം. അല്ലാതെ ഇമെയിലും പാസ്‌വേഡും നൽകുകയാണെങ്കിൽ, 'Sign Up' ബട്ടൺ അമർത്തുമ്പോൾ നിങ്ങളുടെ ഇമെയിലിലേക്ക് ഒരു വേരിഫിക്കേഷൻ ലിങ്ക് വരുന്നതായിരിക്കും. (Inbox-ൽ കണ്ടില്ലെങ്കിൽ Spam ഫോൾഡർ പരിശോധിക്കുക). ആ ലിങ്കിൽ ക്ലിക്ക് ചെയ്താൽ മാത്രമേ അക്കൗണ്ട് ആക്റ്റീവ് ആവുകയുള്ളൂ."
    },
    {
      q: "എങ്ങനെയാണ് ഇതിൽ ലോഗിൻ ചെയ്യുന്നത് (Login)?",
      a: "ലോഗിൻ പേജിൽ 'Continue with Google' ബട്ടൺ ക്ലിക്ക് ചെയ്ത് നിങ്ങൾക്ക് നേരിട്ട് ലോഗിൻ ചെയ്യാം. ഇനി ഇമെയിലും പാസ്‌വേഡും നൽകിയാണ് അക്കൗണ്ട് എടുത്തതെങ്കിൽ ആ വിവരങ്ങൾ നൽകി 'Sign In with Email' എന്ന ബട്ടൺ അമർത്തുക."
    },
    {
      q: "പാസ്‌വേഡ് മറന്നുപോയാൽ എന്ത് ചെയ്യണം?",
      a: "ലോഗിൻ പേജിൽ നിങ്ങളുടെ ഇമെയിൽ നൽകിയ ശേഷം താഴെയുള്ള 'Forgot Password?' എന്നതിൽ ക്ലിക്ക് ചെയ്യുക. അപ്പോൾ പുതിയ പാസ്‌വേഡ് സെറ്റ് ചെയ്യാനുള്ള ലിങ്ക് നിങ്ങളുടെ ഇമെയിലിലേക്ക് വരുന്നതായിരിക്കും. (ഗൂഗിൾ വഴി ലോഗിൻ ചെയ്തവർക്ക് ഇതിന്റെ ആവശ്യമില്ല)."
    },
    {
      q: "എന്റെ അക്കൗണ്ടും വ്യക്തിവിവരങ്ങളും ഡിലീറ്റ് ചെയ്യാൻ സാധിക്കുമോ?",
      a: "തീർച്ചയായും. പ്രൊഫൈൽ (Profile) പേജിൽ പോയി നിങ്ങളുടെ അക്കൗണ്ടും അതിനോടൊപ്പമുള്ള എല്ലാ വിവരങ്ങളും പൂർണ്ണമായി ഡിലീറ്റ് ചെയ്യാവുന്നതാണ്. ഇത് നിങ്ങളുടെ ഡാറ്റയുടെ സുരക്ഷ ഉറപ്പാക്കുന്നു."
    },
    {
      q: "എങ്ങനെയാണ് പുതിയ ടൂറിസ്റ്റ് സ്ഥലങ്ങളോ മറ്റ് വിവരങ്ങളോ ചേർക്കുന്നത്?",
      a: "പുതിയ സ്ഥലങ്ങൾ ചേർക്കാൻ മുകളിലുള്ള ഫോം വഴി ഞങ്ങൾക്ക് ആ സ്ഥലത്തിന്റെ പേരും വിവരങ്ങളും അയച്ചു തരിക (അല്ലെങ്കിൽ വാട്സാപ്പ് ചെയ്യുക). അഡ്മിൻ അത് പരിശോധിച്ച ശേഷം വെബ്സൈറ്റിൽ ചേർക്കുന്നതാണ്."
    },
    {
      q: "രക്തദാതാക്കളുടെ (Blood Donors) വിവരങ്ങൾ എങ്ങനെ അപ്ഡേറ്റ് ചെയ്യാം?",
      a: "ലോഗിൻ ചെയ്ത് പ്രൊഫൈൽ (Profile) പേജിൽ പോയാൽ നിങ്ങൾക്ക് തന്നെ സ്വന്തം വിവരങ്ങൾ ചേർക്കാനും, തിരുത്താനും ആവശ്യമെങ്കിൽ ഒറ്റ ക്ലിക്കിൽ ഡിലീറ്റ് ചെയ്യാനും സാധിക്കുന്നതാണ്."
    },
    {
      q: "എങ്ങനെയാണ് തൊഴിലാളികളുടെയും (Labour) ഡ്രൈവർമാരുടെയും വിവരങ്ങൾ ചേർക്കുന്നത്?",
      a: "ഹോം പേജിൽ നിന്ന് 'Labours' അല്ലെങ്കിൽ 'Drivers' സെക്ഷനിൽ കയറുക. അവിടെ കാണുന്ന 'Register' ബട്ടണിൽ ക്ലിക്ക് ചെയ്താൽ നിങ്ങളുടെ വിവരങ്ങൾ നേരിട്ട് നൽകി രജിസ്റ്റർ ചെയ്യാവുന്നതാണ്. ഇതിനായി നിങ്ങൾ ലോഗിൻ ചെയ്തിരിക്കണം."
    },
    {
      q: "ഈ സേവനം പൂർണ്ണമായും സൗജന്യമാണോ?",
      a: "അതെ, ഇൻഫോ പഴയങ്ങാടി യാതൊരുവിധ സാമ്പത്തിക ലാഭവും ഇല്ലാതെ ജനങ്ങൾക്ക് ഉപകാരപ്രദമാകുന്ന രീതിയിൽ തികച്ചും സൗജന്യമായാണ് പ്രവർത്തിക്കുന്നത്."
    }
  ];

  return (
    <>
      <Helmet>
        <title>Help & Contact | Info Payangadi</title>
        <meta name="description" content="Contact Info Payangadi team or find answers to frequently asked questions." />
      </Helmet>

      <div className="min-h-[100dvh] bg-[#F8FAFC] pb-24 selection:bg-blue-200 overflow-x-hidden relative">
        
        {/* 🔥 Premium Background Glows 🔥 */}
        <div className="absolute top-[-10%] left-[-10%] w-[350px] h-[350px] bg-blue-400/15 rounded-full blur-[100px] pointer-events-none"></div>
        <div className="absolute top-[30%] right-[-10%] w-[350px] h-[350px] bg-cyan-400/10 rounded-full blur-[100px] pointer-events-none"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-8 md:pt-16 relative z-10">
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="space-y-12 sm:space-y-16"
          >
            
            {/* 1. HERO SECTION */}
            <motion.div variants={itemVariants} className="text-center space-y-4 px-2">
              <div className="inline-flex items-center justify-center p-4 bg-white text-blue-600 rounded-[1.5rem] mb-2 shadow-[0_8px_30px_rgb(37,99,235,0.08)] border border-blue-50/50">
                <MessageCircle size={32} strokeWidth={2.5} />
              </div>
              <h1 className="text-3xl sm:text-5xl font-black text-slate-800 tracking-tight leading-tight">
                Help & <span className="text-blue-600">Contact</span>
              </h1>
              <p className="text-base sm:text-lg text-slate-500 max-w-xl mx-auto leading-relaxed font-medium">
                നിങ്ങൾക്ക് എന്തെങ്കിലും സംശയങ്ങളുണ്ടെങ്കിലോ പുതിയ വിവരങ്ങൾ ചേർക്കണമെങ്കിലോ ഞങ്ങളെ ബന്ധപ്പെടാവുന്നതാണ്.
              </p>
            </motion.div>

            {/* 2. CONTACT INFO & FORM GRID */}
            <motion.div variants={itemVariants} className="grid md:grid-cols-5 gap-6 sm:gap-8">
              
              {/* Left Side: Contact Information */}
              <div className="md:col-span-2">
                <div className="bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-black text-white p-8 sm:p-10 rounded-[2.5rem] shadow-[0_20px_40px_rgba(15,23,42,0.2)] border border-slate-700/50 relative overflow-hidden h-full group">
                  
                  <div className="absolute top-0 right-0 w-48 h-48 bg-blue-500/20 rounded-bl-full blur-3xl pointer-events-none transition-transform duration-700 group-hover:scale-110"></div>
                  <div className="absolute bottom-0 left-0 w-48 h-48 bg-cyan-500/20 rounded-tr-full blur-3xl pointer-events-none transition-transform duration-700 group-hover:scale-110"></div>

                  <div className="relative z-10 flex flex-col h-full">
                    <h3 className="text-2xl sm:text-3xl font-black mb-8 tracking-tight">Get in Touch</h3>
                    
                    <div className="space-y-8 flex-1">
                      <div className="flex items-start gap-4 group/item">
                        <div className="p-3.5 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl group-hover/item:bg-blue-500/20 transition-colors">
                          <Mail className="text-blue-300" size={22} strokeWidth={2.5} />
                        </div>
                        <div>
                          <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">Email Us</p>
                          <a href="mailto:payangadilive@gmail.com" className="font-semibold text-sm sm:text-base hover:text-blue-300 transition-colors break-all">
                            payangadilive@gmail.com
                          </a>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 group/item">
                        <div className="p-3.5 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl group-hover/item:bg-green-500/20 transition-colors">
                          <Phone className="text-green-400" size={22} strokeWidth={2.5} />
                        </div>
                        <div>
                          <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">WhatsApp</p>
                          <a href="https://wa.me/917306422610" target="_blank" rel="noopener noreferrer" className="font-semibold text-sm sm:text-base hover:text-green-400 transition-colors">
                            +91 73064 22610
                          </a>
                        </div>
                      </div>

                      <div className="flex items-start gap-4 group/item">
                        <div className="p-3.5 bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl group-hover/item:bg-red-500/20 transition-colors">
                          <MapPin className="text-red-400" size={22} strokeWidth={2.5} />
                        </div>
                        <div>
                          <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-1">Location</p>
                          <p className="font-medium text-sm sm:text-base leading-relaxed text-slate-300">
                            Payangadi, Kannur <br/> Kerala, 670303
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side: Contact Form */}
              <div className="md:col-span-3 bg-white p-7 sm:p-10 rounded-[2.5rem] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100">
                <h3 className="text-2xl font-black text-slate-800 mb-6 tracking-tight">Send a Message</h3>
                
                <form onSubmit={handleSubmit} className="space-y-5">
                  <div className="grid sm:grid-cols-2 gap-5">
                    <div className="space-y-2">
                      <label className="text-xs font-bold uppercase tracking-wider text-slate-500 ml-1">Your Name</label>
                      <input 
                        type="text" 
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Enter your name" 
                        className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl focus:bg-white focus:ring-4 focus:ring-blue-500/10 focus:border-blue-400 outline-none transition-all font-semibold text-sm placeholder:text-slate-400 placeholder:font-medium text-slate-800"
                      />
                    </div>
                    <div className="space-y-2">
                      <label className="text-xs font-bold uppercase tracking-wider text-slate-500 ml-1">Phone Number</label>
                      <input 
                        type="tel" 
                        required
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        placeholder="WhatsApp number" 
                        className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl focus:bg-white focus:ring-4 focus:ring-blue-500/10 focus:border-blue-400 outline-none transition-all font-semibold text-sm placeholder:text-slate-400 placeholder:font-medium text-slate-800"
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="text-xs font-bold uppercase tracking-wider text-slate-500 ml-1">Message / Suggestions</label>
                    <textarea 
                      rows="4" 
                      required
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      placeholder="How can we help you?" 
                      className="w-full px-5 py-4 bg-slate-50 border border-slate-100 rounded-2xl focus:bg-white focus:ring-4 focus:ring-blue-500/10 focus:border-blue-400 outline-none transition-all font-semibold text-sm placeholder:text-slate-400 placeholder:font-medium text-slate-800 resize-none"
                    ></textarea>
                  </div>

                  <motion.button 
                    whileTap={{ scale: 0.97 }}
                    type="submit" 
                    className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-black px-6 py-4 rounded-2xl transition duration-300 shadow-lg shadow-blue-600/25 mt-2"
                  >
                    <Send size={18} strokeWidth={3} />
                    Send via WhatsApp
                  </motion.button>
                </form>
              </div>
              
            </motion.div>

            {/* 3. FREQUENTLY ASKED QUESTIONS (FAQ) */}
            <motion.div variants={itemVariants} className="pt-8 sm:pt-12">
              <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 mb-8 px-2">
                <div className="p-3 bg-blue-100 text-blue-600 rounded-2xl w-max">
                  <HelpCircle size={28} strokeWidth={2.5} />
                </div>
                <div>
                  <h2 className="text-2xl sm:text-3xl font-black text-slate-800 tracking-tight">Frequently Asked Questions</h2>
                  <p className="text-sm font-medium text-slate-500 mt-1">Answers to common queries</p>
                </div>
              </div>
              
              <div className="grid gap-4 sm:gap-5">
                {faqs.map((faq, index) => (
                  <motion.div 
                    key={index}
                    whileHover={{ y: -2 }}
                    className="bg-white p-6 sm:p-8 rounded-[2rem] shadow-[0_8px_30px_rgb(0,0,0,0.03)] border border-slate-100 group transition-all"
                  >
                    <h4 className="text-base sm:text-lg font-black text-slate-800 mb-3 flex items-start gap-3 tracking-tight">
                      <div className="mt-1 bg-blue-50 p-1 rounded-lg flex-shrink-0 group-hover:bg-blue-600 group-hover:text-white transition-colors text-blue-500">
                        <Sparkles size={16} strokeWidth={3} />
                      </div>
                      {faq.q}
                    </h4>
                    <p className="text-slate-500 pl-10 leading-relaxed text-sm sm:text-base font-medium">
                      {faq.a}
                    </p>
                  </motion.div>
                ))}
              </div>
            </motion.div>

          </motion.div>
        </div>
      </div>
    </>
  );
}